export const cleanString = (inputString) => {
    return inputString.replace(/[^a-zA-Z0-9_-]/g, '');
}
export const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
export const formatCurrency = (value, locale = 'en-US', currency = 'USD') => {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    });
  
    const formattedValue = formatter.format(Math.abs(value));
    return value < 0 ? `(${formattedValue})` : formattedValue;
};

export const ucwords = (str) => {
    return str
      .split(' ')             // Split the string into words
      .map(word =>             // Map over each word
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');             // Join the words back into a string
}
export const isWindows = () => {
  const userAgent = window.navigator.userAgent;
  if (userAgent.indexOf("Win") !== -1) return true;
  return false;
}
export const getFileType = (file) => {
  return new Promise((resolve, reject) => {
      const fileNameParts = file.name.split('.');
      if (fileNameParts.length > 1) {
          const extension = fileNameParts.pop();
          const mimeType = getFileTypeFromExtension(extension);
          resolve(mimeType);
      } else {
          reject(new Error("File extension not found."));
      }
  });
};

const getFileTypeFromExtension = (extension) => {
  const mimeTypeMap = {
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      zip: "application/zip",
      odt: "application/vnd.oasis.opendocument.text",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      pdf: "application/pdf",
      txt: "text/plain",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      heic: "image/heic",
      heif: "image/heif"
      // Add more file extensions and their corresponding MIME types as needed
  };

  const lowercaseExtension = extension.toLowerCase();
  return mimeTypeMap[lowercaseExtension] || "application/octet-stream"; // Default to binary/octet-stream if extension is not found
};

export const removeLastSubstring = (str, delimiter) => {
  const lastIndex = str.lastIndexOf(delimiter);
  if (lastIndex !== -1) {
      return str.substring(0, lastIndex);
  }
  return str; // Return the original string if the delimiter is not found
}
export const splitFromLastDot = (str) => {
  if (str == undefined) {
    return {first: "", last: "" };
  }
  const lastDotIndex = str.lastIndexOf('.');
  // If there is no dot in the string, return the whole string as both first and last
  if (lastDotIndex === -1) {
      return { first: str, last: str };
  }

  // Split the string into two parts: before and after the last dot
  const first = str.substring(0, lastDotIndex);
  const last = str.substring(lastDotIndex + 1);
  return { first, last };
}

export const getFileNameWithOutExtension = (fileName) => {
    // Get the index of the last dot in the file name
    const lastDotIndex = fileName.lastIndexOf('.');
    
    // If there's no dot, return the original file name
    if (lastDotIndex === -1) {
        return fileName;
    }
    
    // Return the substring from the start to the last dot
    return fileName.substring(0, lastDotIndex);
}
export const formatFileSize = (bytes, type = '') => {
  const units = ['Bytes', 'KB', 'MB', 'GB'];
  let index = 0;

  // Determine the index based on the type or size
  if (type === 'MB') {
    return (bytes / (1024 * 1024)).toFixed(2); // Return value in MB without the unit
  } else if (type === 'KB') {
    return (bytes / 1024).toFixed(2) + ' KB';
  } else {
    while (bytes >= 1024 && index < units.length - 1) {
      bytes /= 1024;
      index++;
    }
  }

  return `${bytes.toFixed(2)} ${units[index]}`;
}



export const formatFileExtension = (extension) => {
  // Remove the dot if it exists and convert to uppercase
  const cleanedExtension = extension.startsWith('.') ? extension.slice(1) : extension;
  return cleanedExtension.toUpperCase();
}